import { render, staticRenderFns } from "./RecentSearches.vue?vue&type=template&id=74fd07ae"
import script from "./RecentSearches.vue?vue&type=script&lang=js"
export * from "./RecentSearches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports